module.exports = __webpack_public_path__ + "static/media/cy.3a1787e2.png";